import { ILoaiChungChi } from "../../../model/response/category/ILoaiChungChi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eLoaiChungChiActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ILoaiChungChi[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as ILoaiChungChi | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as ILoaiChungChi,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
}
export const eLoaiChungChiActionIds = generateActionTypeIds(eLoaiChungChiActionsObj, "LOAI_CHUNG_CHI");
export type ILoaiChungChiActionTypes = IGenericActionType<typeof eLoaiChungChiActionsObj, "LOAI_CHUNG_CHI">;